import { ApolloPlugin } from "@products/base-portal-lib/plugins";

export default defineNuxtPlugin({
	name: "apollo",
	order: 1000,
	setup: (nuxtApp) => {
		const config = useRuntimeConfig();

		const errorHandler = (error) => {
			if (error.graphQLErrors?.length) {
				const isAuthError = error.graphQLErrors.find(
					(e) =>
						e.extensions?.code === "AUTH_NOT_AUTHORIZED" ||
						e.extensions?.code === "AUTH_NOT_AUTHENTICATED"
				);
				if (isAuthError) {
					showError({ statusCode: 403.999 });
				}
			}
		};

		const clientConfigurator = (apolloClient) => {
			if (process.server) {
				nuxtApp.hook("app:rendered", () => {
					nuxtApp.payload.data.apollo = apolloClient.extract();
				});
			}
		};

		nuxtApp.vueApp.use(ApolloPlugin, {
			httpLink: config.public.GRAPHQL_URL,
			wsLink: config.public.GRAPHQL_WS,
			clientConfigurator,
			errorHandler,
			useFakeApolloProvider: true,
		});
	},
});
